import vars from '../helpers';

const $document = vars.$document;
const $teamWindow = vars.$document.find('.footer__team-project--js');

function clickHandler() {
	if (event.target.dataset.type === 'team') {
		return;
	}

	if (event.target.dataset.type === 'team-btn' && !$teamWindow.hasClass('is-active')) {
		$teamWindow.addClass('is-active');
		setTimeout(() => {
			$teamWindow.addClass('is-visible');
		}, 100);
	} else {
		$teamWindow.removeClass('is-visible');

		setTimeout(() => {
			$teamWindow.removeClass('is-active');
		}, 200);
	}
}

function init() {
	$document.on('click.team', clickHandler);
}

function destroy() {
	$document.off('click.team', clickHandler);
}

export default {
	init,
	destroy,
};
